






















import Button from '../components/parts/Button.vue'
import QrReader from '../components/QrReader.vue'
import { defineComponent, inject } from '@vue/composition-api'
import { key } from '../store'
import router from '../router'

interface IState {
  /** QRコードデータ */
  qrCode: string
}

export default defineComponent({
  name: 'QrReaderP',
  components: {
    Button,
    QrReader,
  },
  setup() {
    const store = inject(key)
    if (!store) {
      throw new Error('')
    }

    return {
      onScan: (code: string) => {
        if (code.match('^<xml xmlns="https://developers.google.com/blockly/xml">.+</xml>$')) {
          store.setQrCode(code)
          router.push({ name: 'ShowBlock' })
        }
      },
    }
  },
})
